<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" lg="9">
        <div class="d-flex justify-space-between">
          <v-btn text @click="reloadAll" class="px-0"><v-icon color="#F15A24">mdi-refresh</v-icon> Atualizar Feed</v-btn>
          <v-btn text @click="verAmigos=true" class="px-0"><v-icon color="#F15A24">mdi-account</v-icon> Amigos</v-btn>
        </div>
        <v-row>
          <v-col v-if="anotacoes.length == 0 && !loadingFeed" cols="12">
            <p class="mt-5">
              Ainda não existe conteúdo por aqui. Faça anotações e conexões para
              alimentar o seu feed.
            </p>
          </v-col>
          <v-col v-if="loadingFeed" cols="12" class="text-center">
            <v-progress-circular  class="mx-auto" color="#F15A24" indeterminate></v-progress-circular>
          </v-col>
            <v-col v-for="(annotation, i) in anotacoes" :key="i" cols="12">
              <annotation :annotation="annotation"></annotation>
            </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="3" v-if="intBreakPoint > 2" class="text-center">
        <BtnAdicionarAmigo :reloadFriends="loadFriendsInvited" class="mx-auto mb-5"></BtnAdicionarAmigo>
          <div class="gt-tag mx-auto w-100" :style="{backgroundColor: `#e1e1e1`}">
                <h4><v-icon color="white">mdi-account</v-icon> Amigos</h4>
          </div>
          <v-list style=" max-height:30vh; overflow-y: auto;">
            <v-list-item v-for="u in friends" :key="u.id">
                <v-list-item-avatar>
                  <v-img width="40px" height="40px"  class="rounded-circle" cover :src="u.id_amigo.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.id_amigo.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " />
                </v-list-item-avatar>
                <v-list-item-content class="text-left">
                  <v-list-item-title class="d-flex text-subtitle-2 " style="white-space: inherit;" >
                    <router-link :to="`/painel/u/${u.id_amigo.id}/${sanitizeTitle(u.id_amigo.first_name)}`" class="">
                      {{ u.id_amigo.first_name }}
                    </router-link>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn alt="excluir" fab x-small icon style="margin-left: 5px;"
                    @click="confirmModal = true; removeId = u.id"><v-icon>mdi-account-remove</v-icon></v-btn>
                </v-list-item-action>
            </v-list-item>
          </v-list>
          <!-- <v-btn v-if="friends.length > 0" text color="#F15A24" class="mb-5">Ver Todos</v-btn> -->
          <div class="gt-tag mx-auto w-100" :style="{backgroundColor: `#e1e1e1`}">
            <h4><v-icon color="white">mdi-account-group</v-icon> Sugestões</h4>
          </div>
          <v-list class="mx-auto">
            <v-list-item v-for="u in suggestFriends" :key="u.id">
              <v-list-item-avatar>
                <router-link :to="`/painel/u/${u.id}/${sanitizeTitle(u.first_name)}`" class="">

                  <v-img width="40px" height="40px" class="rounded-circle" cover :src="u.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " />
                    </router-link>
                </v-list-item-avatar>
                <v-list-item-content class="text-left">
                  <router-link :to="`/painel/u/${u.id}/${sanitizeTitle(u.first_name)}`" class="">
                    <v-list-item-title style="white-space: inherit;">
                      {{ u.first_name }}
                    </v-list-item-title>
                  </router-link>
                </v-list-item-content>
               
                <v-list-item-action class="d-flex flex-row">
                  <!-- <v-btn></v-btn> -->
                </v-list-item-action>
            </v-list-item>
          </v-list>
          <div v-if="groupsWaitingAccept.length > 0 || friendsWaitingAccept.length > 0" class="gt-tag mx-auto w-100" :style="{backgroundColor: `#e1e1e1`}">
                <h4><v-icon color="white">mdi-clock-outline</v-icon> Pendentes</h4>
            </div>
          <v-list class="mx-auto" style="">
            <v-list-item v-for="u in groupsWaitingAccept" :key="u.id">
            
                <v-list-item-avatar>
                  <!-- <v-img width="40px" height="40px" class="rounded-circle" contain :src="u.id_usuario.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.id_usuario.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " /> -->
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="white-space: inherit;">
                    {{ u.id_grupo.nome_grupo }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="d-flex flex-row">
                  <v-btn icon @click="aceitarGrupo(u.id)">
                    <v-icon color="green"  style="cursor: pointer">mdi-check</v-icon>
                  </v-btn>
                  <v-btn icon @click="recusarGrupo(u.id)">
                    <v-icon color="red">mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
  
            </v-list-item>
            <v-list-item v-for="u in friendsWaitingAccept" :key="u.id">
                <v-list-item-avatar>
                  <v-img width="40px" height="40px" class="rounded-circle" cover :src="u.id_usuario.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.id_usuario.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " />
                </v-list-item-avatar>
                <v-list-item-content class="text-left">
                  <v-list-item-title style="white-space: inherit;">
                    {{ u.id_usuario.first_name }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="d-flex flex-row">
                  <v-btn icon @click="aceitarAmizade(u.id)">
                    <v-icon color="green"  >mdi-check</v-icon>
                  </v-btn>
                  <v-btn icon @click="recusarAmizade(u.id)">
                    <v-icon color="red">mdi-close
                  </v-icon>
                  </v-btn>

                </v-list-item-action>
            </v-list-item>

            <!-- <v-list-item style="opacity: 0.5" v-for="u in friendsInvited" :key="u.id">
              <div v-if="u.id_adicionado" style="display: flex;">
                <v-list-item-avatar>
                  <v-img width="40px" height="40px" class="rounded-circle" cover :src="u.id_adicionado.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.id_adicionado.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " />
                </v-list-item-avatar>
                <v-list-item-content class="text-left">
                  <v-list-item-title style="white-space: inherit;">
                      {{ u.id_adicionado.first_name }}
                    </v-list-item-title>
                  <v-list-item-subtitle>
                    <small>convite enviado</small>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action >
                  
                  </v-list-item-action>

              </div>
            </v-list-item> -->
          </v-list>
      </v-col>
    </v-row>
    <v-dialog v-model="confirm" width="25vw">
      <v-card style="
          height: 120px !important;
          overflow-x: hidden !important;
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
        ">
        <v-row>
          <v-col cols="12" md="12">
            <h2 style="gap: 1rem; text-align: center; color: #f15a24">
              <v-icon>mdi-account-check</v-icon>
              {{ mensagemConfirm }}
            </h2>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmModal" width="35%">
      <div style="display: flex; justify-content: center;">
        <v-card width="100%">
          <v-card-title>
            Excluir amigo
          </v-card-title>
          <v-card-subtitle>
            Confirme a ação
          </v-card-subtitle>
          <v-card-actions>
            <v-btn @click="confirmModal = false">Cancelar</v-btn>
            <v-btn @click="excluirAmizade(removeId)">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="verAmigos">
      <v-card>
        <v-card-title>
          Meus Amigos
        </v-card-title>
        <v-card-text>
          <!-- <div class="gt-tag mx-auto" :style="{backgroundColor: `#e1e1e1`}">
                <h4><v-icon color="white">mdi-account</v-icon> Amigos</h4>
            </div> -->
          <v-list class="mx-auto" style="width: 100%">
            <v-list-item v-for="u in friends.slice(0, 4)" :key="u.id">
              <div v-if="u.id_amigo" style="display: flex;" @mouseover="profileDetails = u.id"
                @mouseleave="profileDetails = null">
                <v-list-item-avatar>
                  <v-img width="40px" height="40px"  class="rounded-circle" cover :src="u.id_amigo.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.id_amigo.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " />
                </v-list-item-avatar>
                <v-list-item-content  class="d-flex justify-space-between">
                  <v-list-item-title class="d-flex text-subtitle-2 " style="white-space: inherit;" >
                    <router-link :to="`/painel/u/${u.id_amigo.id}/${sanitizeTitle(u.id_amigo.first_name)}`" class="userProfile">
                      {{ u.id_amigo.first_name }}
                    </router-link>
                  </v-list-item-title>
                  <v-list-item-action v-if="profileDetails == u.id">
                      <v-btn alt="excluir" fab x-small outlined style="margin-left: 5px;"
                        @click="confirmModal = true; removeId = u.id"><v-icon>mdi-account-remove</v-icon></v-btn>
                    </v-list-item-action>
                </v-list-item-content>
              </div>
            </v-list-item>
          </v-list>
          <!-- <v-btn v-if="friends.length > 0" text color="#F15A24" class="mb-5">Ver Todos</v-btn> -->
          <BtnAdicionarAmigo :reloadFriends="loadFriendsInvited"  class="text-center"></BtnAdicionarAmigo>

          <div class="gt-tag mx-auto " :style="{backgroundColor: `#e1e1e1`}">
                <h4><v-icon color="white">mdi-clock-outline</v-icon> Pendentes</h4>
            </div>
          <v-list class="mx-auto" style="width: 100%">
            <v-list-item v-for="u in groupsWaitingAccept" :key="u.id">
              <div v-if="u.id_grupo" style="display: flex;">
                <v-list-item-avatar>
                  <!-- <v-img width="40px" height="40px" class="rounded-circle" contain :src="u.id_usuario.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.id_usuario.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " /> -->
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="white-space: inherit;">
                    {{ u.id_grupo.nome_grupo }}
                  </v-list-item-title>
                </v-list-item-content>
                <div>
                  <v-icon color="grend" @click="aceitarGrupo(u.id)" style="cursor: pointer">mdi-check</v-icon>
                  <v-icon color="red" @click="recusarGrupo(u.id)" style="cursor: pointer">mdi-close
                  </v-icon>
                </div>
              </div>
            </v-list-item>
            <v-list-item v-for="u in friendsWaitingAccept" :key="u.id">
              <div v-if="u.id_usuario" style="display: flex;" class="align-center justify-between">
                <v-list-item-avatar>
                  <v-img width="40px" height="40px" class="rounded-circle" contain :src="u.id_usuario.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.id_usuario.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="white-space: inherit;">
                    {{ u.id_usuario.first_name }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action >
                  <v-icon color="grend" @click="aceitarAmizade(u.id)" style="cursor: pointer">mdi-check</v-icon>
                  <v-icon color="red" @click="recusarAmizade(u.id)" style="cursor: pointer">mdi-close
                  </v-icon>
                </v-list-item-action>
              </div>
            </v-list-item>

            <v-list-item style="opacity: 0.5" v-for="u in friendsInvited" :key="u.id">
              <div v-if="u.id_adicionado" style="display: flex;">
                <v-list-item-avatar>
                  <v-img width="40px" height="40px" class="rounded-circle" contain :src="u.id_adicionado.avatar !== null
                      ? `https://api.mylegis.com.br/assets/${u.id_adicionado.avatar}`
                      : require(`../assets/icon-person.svg`)
                    " />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="white-space: inherit;">
                    {{ u.id_adicionado.first_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <small>convite enviado</small>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </div>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.stickyCol {
  position: sticky;
  position: -webkit-sticky;
  top: 20px;
  align-items: start;
  display: inline-block;
}

.colDica {
  background-color: #f5f3f2;
}

.colDica:hover,
.colNoticia:hover,
.colArtigo:hover {
  background-color: #dfdbd6;
}


.annotation {
  border: 1px solid rgb(200 200 200) !important;
  margin: 8px 0px;
  border-radius: 10px;
}

.annotationText div {
  width: 100%;
}

.secondRow h3 {
  margin: 30px 0px 0px 15px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}

.secondRow p {
  padding: 10px 15px;
  background-color: #472f8c;
  color: white;
  width: 100%;
}

a {
  text-decoration: none;
  color: black;
}

a:hover {
  text-decoration: underline;
  color: #F15A24;
}

.colDica a {
  color: black;
}

.colNoticia a:hover {
  text-decoration-color: black;
}

.reg {
  border: 1px dashed gray;
  border-radius: 10px;
  padding: 5px;
}
.anno a { 
  color:#F15A24 !important;
  text-decoration:none;
  padding:0
}

a:hover { 
  text-decoration:underline;
}
</style>

<script>
// import AvatarDpo from '../components/AvatarDpo.vue';
import BtnAdicionarAmigo from "../components/BtnAdicionarAmigo.vue";
import Annotation from "../components/Annotation.vue"
export default {
  name: "HomeFeed",
  components: { BtnAdicionarAmigo, Annotation },
  data() {
    return {
      confirm: false,
      comment: "",
      confirmModal: false,
      verAmigos: false,
      profileDetails: null,
      importPost: { id_lei: {}, id_reg: {} },
      mensagemConfirm: "",
      showNewAnnotation: false,
      loadingNewAnnotation: false,
      searchText: "",
      friends: [],
      friendsInvited: [],
      friendsWaitingAccept: [],
      groupsWaitingAccept: [],
      suggestFriends: [ ],
      anotacoes: [],
      loadingFeed: false,
      removeId:null,
      statusAnnotation: [
        { text: "Público", value: "published" },
        { text: "Grupo", value: "group" },
        { text: "Privado", value: "private" },
        { text: "Apenas Amigos", value: "friend" },
        { text: "Arquivado", value: "archived" },
      ],
      customToolbar: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        [
          { header: "1" },
          { header: "2" },
          "blockquote",
          "code-block",
        ],

        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
      customToolbar1: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        [{ header: "1" }, { header: "2" }, "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
    };
  },
  async mounted() {
    if (this.user !== undefined) {
      this.$store.dispatch('realoadVadeMecuns')
      this.loadFriends();
      this.loadFriendsInvited();
      this.loadFriendsWaitingAccept();
      this.loadSuggestFriends()
      this.loadGroupsWaitingAccept()
      await this.loadFriendsFeed();
      await this.loadGroupsFeed();
      this.loadFeed();
      
    }
  },
  watch: {
    // user: async function () {
    //   this.loadFriends();
    //   this.loadFriendsInvited();
    //   this.loadFriendsWaitingAccept();
    //   await this.loadFriendsFeed();
    //   await this.loadGroupsFeed();
    //   this.loadFeed();
    // },
  },
  methods: {

  async reloadAll(){ 
    this.anotacoes = []
    this.loadFriends();
      this.loadFriendsInvited();
      this.loadFriendsWaitingAccept();
      this.loadGroupsWaitingAccept()
      await this.loadFriendsFeed();
      await this.loadGroupsFeed();
      this.loadFeed();
  },
    async loadFeed() {
      this.loadingFeed = true;
      const query = `
        query PublicAnnotations {
          anotacoes(filter: { status: { _eq: "published" } }) {
            id
            texto
            date_created
            likes { 
              id 
              first_name
            }
            date_updated
            status
            comentarios(filter: { status: { _eq: "published"}}) { 
              id
              message
              files {
                id
                directus_files_id { 
                  id
                  filename_download
                }             
              }
              user_created { 
                id
                first_name
                avatar { 
                  id
                }
              }
            }
            user_created {
              first_name
              last_name
              id
              avatar { 
                id 
              }
            }
            id_lei {
              id_lei
              numero_lei
            }
            id_reg { 
              id_reg
              conteudo
            }
          }
        }`;

      const {
        data: { data },
      } = await this.$http.post("/graphql", {
        query,
      });
      this.anotacoes = this.anotacoes.concat(data.anotacoes);

      this.anotacoes.sort(
        (a, b) => {
          return new Date(b.date_created) - new Date(a.date_created)
        }
      );

      this.loadingFeed = false;
    },
    async loadFriendsFeed() {
      this.loadingFeed = true;
      const query = `query FriendsAnnotations($user_id:String){
        anotacoes(
          filter: {user_created: {amigos: {id_amigo: {id: {_eq: $user_id}}}}, status: {_eq: "friend"}}
        ) {
          id
          date_created
          date_updated
          texto
          likes { 
            id 
            first_name
          }
          status
          user_created {
              first_name
              last_name
              id
              avatar { 
                id 
              }
            }
            id_lei {
              id_lei
              numero_lei
            }
            id_reg { 
              id_reg
              conteudo
            }
        }
      }`;
      const variables = {
        user_id: this.user.id,
      };
      const {
        data: { data },
      } = await this.$http.post("/graphql", {
        query,
        variables,
      });
      this.anotacoes = this.anotacoes.concat(data.anotacoes);
    },
    async loadGroupsFeed() {
      const query = `query GroupsAnnotations($user_id:String){
        anotacoes(
          filter: { id_grupo: { integrantes: { directus_users_id: { id: { _eq: $user_id}}}}, status: {_eq: "group"}}
        ) {
          id
          date_created
          date_updated
          texto
          status
          likes { 
            id 
            first_name
          }
          user_created {
              first_name
              last_name
              id
              avatar { 
                id 
              }
            }
            id_grupo { 
              id
              nome_grupo
            }  
          id_lei {
            id_lei
            numero_lei
          }
          id_reg { 
              id_reg
              conteudo
            }
        }
      }`;
      const variables = {
        user_id: this.user.id,
      };
      const {
        data: { data },
      } = await this.$http.post("/graphql", {
        query,
        variables,
      });
      this.anotacoes = this.anotacoes.concat(data.anotacoes);
    },
    async loadFriends() {
      const {
        data: {
          data: { amigos },
        },
      } = await this.$http.get(
        `users/${this.user.id}?fields=amigos.id_amigo.id,amigos.id_amigo.avatar,amigos.id_amigo.first_name,amigos.id_amigo.last_name,amigos.id`
      );
      this.friends = amigos;
      // window.console.log(this.friends)
    },
    async loadSuggestFriends() {
      let suggestIds = [ 
        '2112b577-7c91-47c7-82c5-080a2a3f555c',
        '9ec0bfad-f4fe-4f7f-8686-b0cd5a86c274',
        'f98bc34a-e46b-4392-9a68-8bc76a1694a5',
        'f50cf686-94f2-432a-a7a7-5fa2c70a5b7d',
        '7da54d20-e456-4dda-b50a-912cf0de106f',
        'a0c26080-6199-48d5-b94d-90cd527af285'
      ]
      const {
        data
      } = await this.$http.get(
        `users/?fields=id,first_name,avatar,last_name
              &filter[id][_in]=${suggestIds}`
      );
      this.suggestFriends = data.data;
      // window.console.log(this.friends)
    },
    async loadFriendsInvited() {
      const dt = await this.$http.get(
        `items/add_amigo/?fields=id,id_adicionado.id,id_adicionado.first_name,id_adicionado.avatar,id_adicionado.last_name&filter[status][_eq]=pendente&filter[id_usuario][_eq]=${this.user.id}`
      );
      this.friendsInvited = dt.data.data;
    },
    async loadFriendsWaitingAccept() {
      const dt = await this.$http.get(
        `items/add_amigo/?fields=id,id_usuario.id,id_usuario.first_name,id_usuario.avatar,id_usuario.last_name&filter[status][_eq]=pendente&filter[id_adicionado][_eq]=${this.$store.state.user.id}`
      );
      this.friendsWaitingAccept = dt.data.data;
      // window.console.log(this.friends);
    },
    async loadGroupsWaitingAccept() {
      const dt = await this.$http.get(
        `items/add_grupos/?fields=id,id_grupo.id,id_grupo.nome_grupo&filter[status][_eq]=pendente&filter[id_usuario][_eq]=${this.$store.state.user.id}`
      );
      this.groupsWaitingAccept = dt.data.data;
      // window.console.log(this.friends);
    },
    async aceitarAmizade(id) {
      const dt = await this.$http.patch(`items/add_amigo/${id}`, {
        status: `aceito`,
      });
      if (dt.data.data.id === id) {
        this.mensagemConfirm = "Solicitação aceita!";
        this.confirm = true;
        this.loadFriendsWaitingAccept();
        this.loadFriends();
      }
    },
    async excluirAmizade(id) {
      const dt = await this.$http.delete(`items/meus_amigos/${id}`)
      this.confirmModal = false
        this.loadFriends();
        window.console.log(dt)
    },
    async recusarAmizade(id) {
      const dt = await this.$http.patch(`items/add_amigo/${id}`, {
        status: `recusado`,
      });
      if (dt.data.data.id === id) {
        this.mensagemConfirm = "Solicitação recusada!";
        this.confirm = true;
        this.loadFriendsWaitingAccept();
      }
    },
    async aceitarGrupo(id) {
      const dt = await this.$http.patch(`items/add_grupos/${id}`, {
        status: `aceito`,
      });
      if (dt.data.data.id === id) {
        this.mensagemConfirm = "Solicitação aceita!";
        this.confirm = true;
        this.loadGroupsWaitingAccept();
        this.$store.dispatch('getInfo')
        // this.loadFriends();
      }
    },
    async recusarGroupo(id) {
      const dt = await this.$http.patch(`items/add_grupos/${id}`, {
        status: `recusado`,
      });
      if (dt.data.data.id === id) {
        this.mensagemConfirm = "Solicitação recusada!";
        this.confirm = true;
        this.loadGroupsWaitingAccept();
      }
    },
    handleImageAdded(file, Editor, cursorLocation) {
      // window.console.log(file);
      const formData = new FormData();
      formData.append("image", file);
      this.$http
        .post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // window.console.log(response);
          let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
          Editor.insertEmbed(cursorLocation, "image", url);
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    saveNewAnnotation() {
      this.loadingNewAnnotation = true;
      let dt = {
        id_lei: this.importPost.id_lei,
        id_reg: this.importPost.id_reg,
        status: this.importPost.status,
        id_grupo: this.importPost.status == `group` ? this.importPost.id_grupo : null,
        texto: this.importPost.texto,
      };
      this.$http
        .post("items/anotacoes", dt)
        .then((response) => {
          if (response.data.data.id != undefined) {
            // this.reloadAnotacoes();
            this.loadingNewAnnotation = false;
            this.showNewAnnotation = false;
            // this.importPost = { status: "private" };
            this.importPost = { id_lei: {}, id_reg: {} },
              this.conteudoSelected = {};


            let conteudo = this.conteudos.find(
              (el) => el.id_reg === dt.id_reg
            );
            if (conteudo.anotacoes)
              conteudo.anotacoes.push(response.data.data);
            else conteudo.anotacoes = [response.data.data];
          }
        })
        .catch(() => {
          this.loadingNewAnnotation = false;
        });
    },
    sanitizeTitle: function (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
  filters: {
    filterStatus(v) {
      switch (v) {
        case "published":
          return "Público";
        case "friend":
          return "Amigos";
        case "group":
          return "Grupo";
        case "private":
          return "Privado";
      }
    },
  },
  computed: {
    groups() {
      return this.$store.state.user.grupos
    },
    user() {
      return this.$store.state.user;
    },
    intBreakPoint() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 0;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 4;
        default:
          return 0;
      }
    },
  },
};
</script>

